import axios from '../axios';

const userApi = {
    changePassword: (data) => axios.post('/User/change-password', data),
    changeUserName: (data) => axios.post('/User/change-username', data),
    changeMobile: (data) => axios.post('/User/change-mobile', data),
    adminResetPassword: (data) => axios.post('/User/admin-reset-password', data),
    forgotPassword: (data) => axios.post('/User/forgot-password', data),
    getAllUsers: (companyId) => axios.get(`/User/AllUser/${companyId}`),
};

export default userApi;
